export const SUBSCRIPTION_TERM_DAYS = 365
export const SUBSCRIPTION_TERM_MS = SUBSCRIPTION_TERM_DAYS * 24 * 60 * 60 * 1000

export function proratedAnnualPrice(annualPrice: number, periodEnd: Date, now = new Date()): number {
  const remainingMs = Math.max(0, periodEnd.getTime() - now.getTime())
  return Math.ceil(annualPrice * remainingMs / SUBSCRIPTION_TERM_MS)
}

export function subscriptionReminderThreshold(daysLeft: number): number | null {
  if (!Number.isFinite(daysLeft) || daysLeft < 1 || daysLeft > 30) return null
  return 30 - Math.floor((30 - Math.floor(daysLeft)) / 7) * 7
}
